import "./HomepageAbout.scss";
import { AboutComponent_Plain } from "../../types/components/homepage/AboutComponent.ts";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
const HomepageAbout = ({ data }: { data: AboutComponent_Plain }) => {
  return (
    <section className="about-us">
      <div className="wrapper">
        <div className="about-us__left">
          <div className="block-title">{data.title}</div>
        </div>
        <div className="about-us__right">
          <div className="about-us__col">
            <BlocksRenderer content={data.content1} />
          </div>
          <div className="about-us__col">
            <BlocksRenderer content={data.content2} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomepageAbout;
